import { useRef } from 'react';
import { getMapConnector } from '../../../shared/maps';
import type { MapHandle } from '../../../shared/maps';

// Resolve once at module load — provider doesn't switch at runtime.
// Phase 4 (#325) migration: was importing `mapbox-gl` directly; now goes
// through the connector so flipping `VITE_MAPS_PROVIDER` routes this page
// through Google or Mapbox without code change.
const { MapView } = getMapConnector();

const defaultCenter = { lat: 37.7749, lng: -122.4194 };

export default function CustomerMap() {
  // Held for parity with the historical Mapbox build (which retained the
  // `mapboxgl.Map` ref). Unused today but harmless — leaving it in place
  // signals "this page can hook into the map imperatively later" without a
  // breaking diff if/when we add markers / overlays.
  const mapHandleRef = useRef<MapHandle | null>(null);

  return (
    <div style={{ padding: '1rem', height: '100%' }}>
      <h1 style={{ marginBottom: '1rem' }}>Customer Map</h1>
      <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
        <MapView
          center={defaultCenter}
          zoom={10}
          style="streets"
          mapRef={(h) => { mapHandleRef.current = h; }}
          style_={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  );
}
